





import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'AppWrapper',
})
export default class AppWrapper extends Vue {}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/uikit/components/AppWrapper/AppWrapper.vue